class AnnouncementBar {
    constructor() {
        this.init();
    }
    init = () => {
        let announcement = document.querySelector('.announcement-bar-slider');
        let speed = announcement?.dataset.speed ? parseInt(announcement?.dataset.speed) * 1000 : 3000;
        let arrow = announcement?.dataset.arrow == "true" ? true : false;
        let autoPlay = announcement?.dataset.autoplay == "true" ? true : false;
        let loop = announcement?.dataset.loop == "true"  ? true : false;


        let settings = {
            loop: loop,
            slidesPerView: 1,
            autoHeight: true,
            autoplay: autoPlay,
            speed,
        }
        if(arrow){
            settings['navigation'] = {
                nextEl: document.querySelector('.swiper-button-next',announcement),
                prevEl: document.querySelector('.swiper-button-prev',announcement)
            }
        }
        const swiper = new Swiper(announcement, settings);
    }
}
if (document.querySelector('.announcement-bar-slider.swiper')) new AnnouncementBar();